import { isAnalyticsConsentGranted } from '@/lib/consent-manager'
import { capturePostHogEvent } from '@/lib/analytics/posthog-client'

/**
 * Consent-aware event helper — the single place client components send
 * conversion events. Dual-fires to GA4 (gtag) and PostHog so existing call
 * sites reach both without changes; GA4 behavior is unchanged (fires ONLY
 * when analytics consent is granted and gtag is loaded), and the PostHog
 * side no-ops on its own when unconfigured or pre-consent. Silently no-ops
 * server-side. Never pass emails, domains, URLs being audited, or any
 * other PII as params — client analytics are directional; the database
 * records remain the source of truth for the Radar funnel.
 *
 * High-volume Radar product events do NOT go through here — they are
 * PostHog-only via the radar-events adapter and must never reach GA4.
 */
export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>
): void {
  if (typeof window === 'undefined') return
  try {
    if (!isAnalyticsConsentGranted()) return
    if (window.gtag) {
      window.gtag('event', name, params)
    }
    capturePostHogEvent(name, params)
  } catch {
    // Analytics must never break the product.
  }
}
